export const formatNumber = (number) => {
  const formatted = number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  return formatted
}

export const formatPrice = (amount: number, currencyEnding = 'ISK') => {
  const formatted = formatNumber(Math.round(amount))
  if (formatted === 'NaN') {
    return `0 ${currencyEnding}`
  }

  switch (currencyEnding) {
    case 'ISK':
      return `${formatted} kr.`
    case 'EUR':
      return `€${formatted}`
    case 'USD':
      return `$${formatted}`
    case 'GBP':
      return `£${formatted}`
    default:
      return `${formatted} ${currencyEnding}`
  }
}
